import * as React from 'react';

import { theme } from '../../../lib/StyledComponents';
import { Caption } from '../../Typography/Caption';
import { SVGIcon } from '../../Icon';

import ProgressTrackerContentWrapper from './ProgressTrackerContentWrapper';
import ProgressTrackerHRule from './ProgressTrackerHRule';
import ProgressTrackerIndicator from './ProgressTrackerIndicator';
import ProgressTrackerStepNumber from './ProgressTrackerStepNumber';
import ProgressTrackerStepWrapper, {
  IProgressTrackerStepWrapperProps,
} from './ProgressTrackerStepWrapper';

interface IProgressTrackerStepProps extends IProgressTrackerStepWrapperProps {
  stepName: string;
  stepNumber: number;
}

const ProgressTrackerStep: React.FC<IProgressTrackerStepProps> = ({
  currentStep = false,
  outstanding = true,
  stepName,
  stepNumber,
}) => (
  <ProgressTrackerStepWrapper
    outstanding={outstanding}
    currentStep={currentStep}
  >
    <ProgressTrackerContentWrapper>
      <ProgressTrackerIndicator>
        {outstanding ? (
          <ProgressTrackerStepNumber>{stepNumber}</ProgressTrackerStepNumber>
        ) : (
        <SVGIcon icon={theme.progressTracker.iconCheckedDone} iconStyle='tertiary' />
        )}
      </ProgressTrackerIndicator>
      <Caption as='span'>{stepName}</Caption>
    </ProgressTrackerContentWrapper>
    <ProgressTrackerHRule />
  </ProgressTrackerStepWrapper>
);

export default ProgressTrackerStep;
